import React, { useEffect, useRef, useState } from "react";
import StepNavigation from "./addNewCourseNavigation";
import StepOne from "./steps/stepOne";
import StepTwo from "./steps/stepTwo";
import StepThree from "./steps/stepThree";
// import StepFour from "./steps/stepFour";
import StepFive from "./steps/stepFive";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CourseCreateSuccessfullModal from "../CourseCreateSuccessfullModal/CourseCreateSuccessfullModal";
import {
  courseCreationAPI,
  courseInformationStepAPI,
  CourseOptionAPI,
  courseInterfaceStepAPI,
  learningObjectivesStepAPI,
  courseMessageForInstructorAPI,
  getCourseByIdForCurriculumAPI,
  uploadDocumentsAPI,
  updateDocumentsAPI,
} from "../../redux/features/courseSlice";
import toast from "react-hot-toast";
import globalFunction from "../../utils/globalFunction";
import DottedLoading from "../DottedLoading/DottedLoading";
import CourseAssignmentToInstructor from "../CourseAssignmentToInstructor/CourseAssignmentToInstructor";

const AddNewCourseForm = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const stepRefs = useRef([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [courseCreated, setCourseCreated] = useState(false);
  const [courseId, setCourseId] = useState(0);
  const [formData, setFormData] = useState({
    courseTitle: "",
    coursesubTitle: "",
    courseDes: "",
    courseInterface: {},
    // learningObjectives: [""],
    // units: [],
    documents: [],
    welcomeMessage: "",
    congratulationsMessage: "",
    subtitle: "",
    subcategory_id: null,
    category_id: null,
    primary_taught: "",
  });
  const [basicInfoOptions, setBasicInfoOptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [levelOptions, setLevelOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [showCourseAssignment, setShowCourseAssignment] = useState(false);
  const [courseAssignId, setCourseAssignId] = useState(0);
  const [isLoading, setIsLoading] = useState(false); // New loading state

  const fetchCourseData = async () => {
    try {
      let courseId = globalFunction.getCourseStorage();
      const res = await dispatch(
        getCourseByIdForCurriculumAPI({ token: auth.token, courseId })
      ).unwrap();
      if (res?.success) {
        let learningObjectiveData = [];
        if (res?.data?.learning_objectives) {
          res?.data?.learning_objectives.map((item) =>
            learningObjectiveData.push(item.objective)
          );
        }
        setCourseAssignId(res?.data?.instructor?.id);

        setFormData({
          courseTitle: res?.data?.title,
          coursesubTitle: res?.data?.subtitle,
          courseDes: res?.data?.description,
          courseInterface: {
            basic_info_option_id: res?.data?.basic_info_option_id,
            level: res?.data?.level_id,
            subtitle: res?.data?.subtitle,
            coursesubTitle: res?.data?.subtitle,
            subcategory: res?.data?.subcategory_id,
            category: res?.data?.category_id,
            taught: res?.data?.primary_taught,
            images: res?.data?.image_urls,
            videos: res?.data?.promo_video_urls,
          },
          // learningObjectives: learningObjectiveData,
          // units: res?.data?.Units,
          documents: res?.data?.documents || [],
          welcomeMessage: res.data.welcome_message,
          congratulationsMessage: res.data.congratulation_message,
          subtitle: res?.data?.subtitle,
          subcategory_id: res?.data?.subcategory_id,
          category_id: res?.data?.category_id,
          primary_taught: res?.data?.primary_taught,
        });
      }
    } catch (error) {
      console.log(error);
      console.log(courseCreated);
    }
  };

  useEffect(() => {
    const fetch = async () => {
      const res = await dispatch(
        CourseOptionAPI({ token: auth.token })
      ).unwrap();

      if (res.success) {
        setBasicInfoOptions(res.data.basicInfoOptions);
        setCategories(res.data.categories);
        setLevelOptions(res.data.levelOptions);
      }
    };

    fetch();

    if (globalFunction.getCourseStorage() > 0) {
      fetchCourseData();
    }
  }, []);

  // Initialize refs for each step
  stepRefs.current = stepRefs.current.length
    ? stepRefs.current
    : Array(4)
        .fill()
        .map(() => React.createRef());

  const steps = [
    <StepOne
      ref={stepRefs.current[0]}
      formData={formData}
      setFormData={setFormData}
    />,
    <StepTwo
      ref={stepRefs.current[1]}
      formData={formData}
      basicInfoOptions={basicInfoOptions}
      categories={categories}
      levelOptions={levelOptions}
      setFormData={setFormData}
      courseId={courseId}
    />,
    <StepThree
      ref={stepRefs.current[2]}
      formData={formData}
      setFormData={setFormData}
      courseId={courseId}
    />,
    // <StepFour
    //   ref={stepRefs.current[3]}
    //   formData={formData}
    //   setFormData={setFormData}
    //   courseId={courseId}
    //   getDataFunc={fetchCourseData}
    // />,
    <StepFive
      ref={stepRefs.current[3]}
      formData={formData}
      setFormData={setFormData}
    />,
  ];

  const stepOneFormHandler = async (formData) => {
    setIsLoading(true); // Show loader
    let payload = {
      title: formData.courseTitle,
      subtitle: formData.coursesubTitle,
      description: formData.courseDes,
    };

    if (globalFunction.getCourseStorage() > 0) {
      try {
        let courseId = globalFunction.getCourseStorage();
        const res = await dispatch(
          courseInformationStepAPI({
            payload,
            token: auth.token,
            courseId: courseId,
          })
        ).unwrap();
        if (res.success) {
          setCourseCreated(true);
          setCourseId(res.data.id);
          fetchCourseData();
          toast.success(res?.message, {
            position: "top-center",
          });
          setCurrentStep((prev) => Math.min(prev + 1, steps.length));
        }
      } catch (error) {
        toast.error(error?.message || "Something went wrong", {
          position: "top-center",
        });
      } finally {
        setIsLoading(false); // Hide loader
      }
    } else {
      try {
        const res = await dispatch(
          courseCreationAPI({ payload, token: auth.token })
        ).unwrap();
        if (res.success) {
          setCourseCreated(true);
          setCourseId(res.data.id);
          toast.success(res?.message, {
            position: "top-center",
          });
          localStorage.setItem("course_creation_id", res.data.id);
          setCurrentStep((prev) => Math.min(prev + 1, steps.length));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false); // Hide loader
      }
    }
  };

  const stepTwoFormHandler = async (formData) => {
    setIsLoading(true); // Show loader
    try {
      let payload = formData?.courseInterface;
      const res = await dispatch(
        courseInterfaceStepAPI({
          payload,
          token: auth.token,
          courseId: courseId,
        })
      ).unwrap();
      if (res.success) {
        toast.success(res?.message, {
          position: "top-center",
        });
        fetchCourseData();
        setCurrentStep((prev) => Math.min(prev + 1, steps.length));
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message || "Something went wrong", {
        position: "top-center",
      });
    } finally {
      setIsLoading(false); // Hide loader
    }
  };

  const stepThreeFormHandler = async (formData) => {
  setIsLoading(true);
  try {
    const documentsPayload =
      stepRefs.current[2].current?.getDocuments() || formData.documents;

    if (!documentsPayload || documentsPayload.length === 0) {
      throw new Error("No documents provided");
    }

    const newDocuments = documentsPayload.filter(
      (doc) => doc.file instanceof File
    );
    const existingDocuments = documentsPayload.filter(
      (doc) => !doc.file || doc.file === null
    );

    console.log("New documents:", newDocuments);
    console.log("Existing documents:", existingDocuments);

    let successMessage = "";

    // ✅ CASE 1: If existing documents are present (update only)
    if (existingDocuments.length > 0 && newDocuments.length === 0) {
      console.log("Updating existing documents...");

      const res = await dispatch(
        updateDocumentsAPI({
          payload: { documents: existingDocuments },
          token: auth.token,
          courseId: courseId,
        })
      ).unwrap();

      if (!res.success) {
        throw new Error(res.message || "Failed to update documents");
      }

      successMessage = "Existing documents updated successfully.";
    }

    // ✅ CASE 2: If there are no existing docs, upload new ones
    else if (existingDocuments.length === 0 && newDocuments.length > 0) {
      console.log("Uploading new documents...");

      const uploadRes = await dispatch(
        uploadDocumentsAPI({
          payload: { documents: newDocuments },
          token: auth.token,
          courseId: courseId,
        })
      ).unwrap();

      if (!uploadRes.success) {
        throw new Error(uploadRes.message || "Failed to upload new documents");
      }

      successMessage = `Successfully uploaded ${newDocuments.length} new document${
        newDocuments.length > 1 ? "s" : ""
      }.`;
    }

    // ✅ CASE 3: Mixed — both existing + new documents
    else if (existingDocuments.length > 0 && newDocuments.length > 0) {
      console.log("Uploading new documents and updating all...");

      const uploadRes = await dispatch(
        uploadDocumentsAPI({
          payload: { documents: newDocuments },
          token: auth.token,
          courseId: courseId,
        })
      ).unwrap();

      if (!uploadRes.success) {
        throw new Error(uploadRes.message || "Failed to upload new documents");
      }

      // Combine old + newly uploaded ones
      const finalDocuments = [
        ...existingDocuments,
        ...(uploadRes.data?.documents || []),
      ];

      const updateRes = await dispatch(
        updateDocumentsAPI({
          payload: { documents: finalDocuments },
          token: auth.token,
          courseId: courseId,
        })
      ).unwrap();

      if (!updateRes.success) {
        throw new Error(updateRes.message || "Failed to update documents");
      }

      successMessage = `Uploaded ${newDocuments.length} new document${
        newDocuments.length > 1 ? "s" : ""
      } and updated course successfully.`;
    }

    toast.success(successMessage, { position: "top-center" });
    setCurrentStep((prev) => Math.min(prev + 1, steps.length));
  } catch (error) {
    console.log("Document upload error:", error);
    toast.error(error?.message || "Failed to process documents", {
      position: "top-center",
    });
  } finally {
    setIsLoading(false);
  }
};


  // const stepfourFormHandler = async () => {
  //   setIsLoading(true); // Show loader
  //   try {
  //     setCurrentStep((prev) => Math.min(prev + 1, steps.length));
  //   } finally {
  //     setIsLoading(false); // Hide loader
  //   }
  // };

  const stepFiveFormHandler = async (formData) => {
    setIsLoading(true); // Show loader
    try {
      let payload = {
        welcome_message: formData?.congratulationsMessage,
        congratulation_message: formData?.welcomeMessage,
      };
      const res = await dispatch(
        courseMessageForInstructorAPI({
          payload,
          token: auth.token,
          courseId: courseId,
        })
      ).unwrap();
      if (res.success) {
        if (auth.role === "Admin") {
          setShowCourseAssignment(true);
        } else {
          setShow(true);
          localStorage.removeItem("uploadedImages");
          localStorage.removeItem("uploadedVideos");
          localStorage.removeItem("uploadedDocuments");
          localStorage.removeItem("course_creation_id");
        }
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong", {
        position: "top-center",
      });
    } finally {
      setIsLoading(false); // Hide loader
    }
  };

  const nextStep = async () => {
    if (stepRefs.current[currentStep - 1].current?.validate) {
      const isValid = stepRefs.current[currentStep - 1].current.validate();
      if (!isValid) return;
    }

    if (currentStep === steps.length) {
      await stepFiveFormHandler(formData);
    } else if (currentStep === 1) {
      await stepOneFormHandler(formData);
    } else if (currentStep === 2) {
      await stepTwoFormHandler(formData);
    } else if (currentStep === 3) {
      await stepThreeFormHandler(formData);
    }
    //  else if (currentStep === 4) {
    //   await stepfourFormHandler();
    // }
  };

  const prevStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      {/* <div className="steps-header py-21 px-28 overflow-hidden">
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="d-flex align-items-center flex-wrap">
            <h3
              className="ah-heading-05 fw-bold me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
              onClick={goBack}
            >
              <span aria-label="Back to courses">
                <span className="icon-arrow-left"></span>
              </span>
              Go Back
            </h3>
          </div>
          <button
            className="btn btn-soft-green fw-semibold no-shadow py-8"
            type="button"
          >
            Preview
          </button>
        </div>
      </div> */}
      {showCourseAssignment ? (
        <CourseAssignmentToInstructor courseAssignId={courseAssignId} />
      ) : (
        <>
          <StepNavigation currentStep={currentStep} />
          <div>{steps[currentStep - 1]}</div>
          <div className="d-flex justify-content-sm-between justify-content-center flex-sm-row flex-column-reverse mt-10 mt-ms-20 mt-md-30 mt-lg-37 flex-wrap gap-2 overflow-hidden">
            <button
              className="btn btn-soft-green px-50 py-12 no-shadow"
              onClick={prevStep}
              disabled={currentStep === 1 || isLoading}
            >
              Back
            </button>

            <button
              className="btn btn-primary px-50 py-12 no-shadow"
              data-type="no-before"
              onClick={nextStep}
              disabled={isLoading}
            >
              {isLoading ? (
                <DottedLoading />
              ) : currentStep === steps.length ? (
                "Finish"
              ) : (
                "Next"
              )}
            </button>
          </div>
        </>
      )}
      <CourseCreateSuccessfullModal
        show={show}
        onClose={() => setShow(false)}
      />
    </>
  );
};

export default AddNewCourseForm;
